/*@ngInject*/
const UIGridSortableHeaderDirective = function (coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {
        $scope.key = $attrs.itemName;

        $scope.toggleSort = function () {
            $scope.requestParams.key = $scope.key;

            if ($scope.requestParams.sortType === 'desc') {
                $scope.requestParams.sortType = 'asc';
            }
            else {
                $scope.requestParams.sortType = 'desc';
            }

            $scope.resetGridHeaders({$value: $scope.requestParams});

            $scope.onToggle({
                params: {
                    key: $scope.key,
                    sortType: $scope.requestParams.sortType
                }
            });
        };

        $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, requestParams) {
            $scope.requestParams = requestParams;
        });
    };

    return {
        restrict: 'AE',
        replace: true,
        scope: {
            itemLabel: '@',
            resizable: '<',
            requestParams: '<',
            resetGridHeaders: '&',
            onToggle: '&'
        },
        link: linkFunction,
        templateUrl: '/ui/columnSort/gridSortableHeader.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiGridSortableHeader', UIGridSortableHeaderDirective);
